module.exports = __webpack_public_path__ + "img/locker-side-icon-disabled.b0f6a211.svg";